import axiosConfig from '../../packs/axios'

export default {
  methods: {
    createAttachment(formData, successCallback, errorCallback) {
      axiosConfig.post('/api/v3/attachments', formData, {'Content-Type': 'multipart/form-data'})
        .then((response) => {
          successCallback(response.data, response.data.errors)
        })
        .catch((error) => {
          errorCallback(`issue uploading ${this.attachmentType}. ${error}`)
        })
    },
  },
}